/**
 * Styled components for client request items.
 */

import styled from 'styled-components';
import { colors } from 'bench-style-constants';

// #region CSS Variables (missing from bench-style-constants)

const cssCoolGray = '#c6c6c6';
const cssLightGray = '#f4f4f4';
const cssRed = '#d86353';
const cssDuration = '0.25s';

// #region CSS Variables

const RequestItemContainer = styled.div`
  display: block;
  box-shadow: 0 1px 0 0 ${colors.charcoal}19; /* 8-digit hex for 10% opacity */

  &:last-child { box-shadow: none; }

  &:hover {
    .request-item_actions {
      opacity: 1;
      pointer-events: auto;
    }
  }
    
  .request-item_container {
    display: flex;
    align-items: flex-start;
    padding: 1rem;

    &.is-complete {
      animation-name: fadein;
      animation-duration: 0.5s;
      color: ${cssCoolGray};
    }
  }

  .request-item_details {
    display: flex;
    flex-direction: column;
    animation-name: fadeIn;
    animation-duration: ${cssDuration};
    padding-right: 2rem;
  }

  .request-item_button {
    padding: 0;
    background: transparent;
    box-shadow: none;
  }

  .request-item_button-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 18px;

    &:hover::before { color: ${colors.charcoal}; }
  }

  .request-item_state-icon {
    &:hover::before {
      content: '4';
    }
  }

  .request-item_content-container {
    flex: 1 1 auto;
    padding: 0 0 0 1rem;
  }

  .request-item_header { display: flex; }

  .request-item_title-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  }

  .request-item_title {
    width: 100%;
    resize: none;
    padding: 0;
    line-height: 24px;
    overflow-y: auto;
    cursor: auto;
    background-color: ${colors.white};
  }

  .request-item_label, .bl-form label {
    color: ${cssCoolGray};
    font-size: 0.6rem;
    letter-spacing: 1.33px;
    text-transform: uppercase;
    line-height: 2;
    margin: 0;
    animation-name: fadein;
    animation-duration: 0.5s;
  }

  .request-item_actions {
    display: flex;
    margin-left: 8px;
    opacity: 0;
    transition: opacity $duration ease-out;
    pointer-events: none;

    .request-item_button:first-child { margin-right: 8px; }
  }

  .request-item_date {
    flex: 0 0 auto;
    align-self: center;
  }

  .request-item_field { margin-top: 1rem; }

  .request-item_select-container {
    position: relative;
    display: flex;
    align-items: center;
    max-width: 220px;
    border-radius: 0.25rem;
    background: ${cssLightGray};
  }

  .request-item_select {
    -webkit-appearance: none;
    height: auto;
    width: 100%;
    margin: 0;
    padding: 0.7rem 40px 0.7rem 1rem;
    border: none;
    line-height: 24px;
    background: transparent;
    z-index: 1;
  }

  .request-item_select-icon {
    position: absolute;
    right: 0.5rem;
  }

  .error-message { color: ${cssRed}; }
}
`;

export default RequestItemContainer;
